import { render, staticRenderFns } from "./MatchupChart.vue?vue&type=template&id=5f2de994&scoped=true"
import script from "./MatchupChart.vue?vue&type=script&lang=ts"
export * from "./MatchupChart.vue?vue&type=script&lang=ts"
import style0 from "./MatchupChart.vue?vue&type=style&index=0&id=5f2de994&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2de994",
  null
  
)

export default component.exports